import { ClipboardCheckIcon, FlaskConicalIcon, HelpCircleIcon, ImageIcon, ListChecksIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  purpose?: string;
  closing?: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Banco de 150 Actividades de Astronomía Listas para el Aula',
    description:
      'Una colección de 150 actividades listas para implementar, organizadas por temáticas astronómicas. Incluye propuestas sobre Sistema Solar, Tierra-Sol-Luna, estrellas, constelaciones, galaxias, cosmología, exoplanetas, exploración espacial y observación del cielo.',
    purpose: 'Tener siempre una actividad disponible sin empezar desde cero',
    value: '$18.000 ARS',
    icon: ListChecksIcon,
  },
  {
    number: '02',
    title: 'Kit Completo de Evaluación de Astronomía — 60 Instrumentos',
    description:
      'Un sistema completo para evaluar los principales contenidos trabajados durante el año, con distintos formatos y niveles de complejidad.',
    items: [
      '60 instrumentos de evaluación',
      'Diferentes formatos y niveles',
      'Respuestas orientativas',
      '100 preguntas adicionales',
      '20 errores frecuentes',
      '5 rúbricas de evaluación',
      '15 estrategias formativas',
    ],
    purpose: 'Evaluar sin crear cada instrumento desde cero',
    value: '$16.000 ARS',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: 'Banco de 100 Proyectos de Astronomía para el Aula',
    description:
      'Una colección de 100 proyectos educativos para transformar los contenidos en experiencias prácticas. Recorren las principales áreas del MEGAPACK y permiten trabajar investigación, experimentación, construcción de modelos, observación, comunicación científica y trabajo colaborativo.',
    purpose: 'Pasar de la teoría a la acción dentro del aula',
    value: '$15.000 ARS',
    icon: FlaskConicalIcon,
  },
  {
    number: '04',
    title: 'Atlas Visual de Astronomía para el Aula',
    description:
      'Un recurso visual diseñado para facilitar la explicación de conceptos difíciles de comprender solo con texto. Incluye 50 recursos visuales organizados en 10 bloques temáticos.',
    items: [
      'Sistema Solar',
      'Tierra, Sol y Luna',
      'Estrellas',
      'Constelaciones',
      'Galaxias',
      'Cosmología',
      'Exoplanetas',
      'Exploración espacial',
      'Instrumentos astronómicos',
      'Observación y fenómenos celestes',
    ],
    purpose: 'Explicar, proyectar y comparar visualmente',
    value: '$14.000 ARS',
    icon: ImageIcon,
  },
  {
    number: '05',
    title: '100 Mitos, Errores y Preguntas Difíciles de Astronomía para el Aula',
    description:
      'Un recurso pensado para esos momentos en los que aparecen preguntas que requieren una explicación clara y científicamente fundamentada. Desde el Big Bang hasta los agujeros negros, los eclipses, los exoplanetas y la posibilidad de vida fuera de la Tierra.',
    items: [
      '100 mitos, errores y preguntas difíciles',
      '10 bloques temáticos',
      'Explicaciones claras para docentes',
      'Respuestas adaptables al aula',
      '20 errores frecuentes adicionales',
      'Guía docente de uso',
    ],
    purpose: 'Responder con mayor seguridad y claridad',
    value: '$13.000 ARS',
    icon: HelpCircleIcon,
    wide: true,
  },
];
